import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

import product_img1 from '../Assets/Images/product_img1.jpg';
import product_img2 from '../Assets/Images/product_img2.jpg';

const initialCartItems = [
  {
    id: 1,
    name: "Light N Care Super Bright Facewash – Ayurvedic Skin Brightening & Anti-Blemish Cleanser (100ml)",
    price: 299,
    quantity: 1,
    image: product_img1,
  },
  {
    id: 2,
    name: "( Jiwandan )Immunity Booster, Strength Body Energy Creator Mass Dhatu Paushtik Improves Stemina, Sarb Rog Nashak Formula",
    price: 1799,
    quantity: 1,
    image: product_img2,
  },
];

const AddCard = () => {
  const [cartItems, setCartItems] = useState(initialCartItems);

  const increaseQty = (id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const decreaseQty = (id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  const deleteItem = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  const estimatedTotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  return (
    <div className="Add_Card_Sec">
      <Container>
        <Row>
          <Col xs={12}>

            {/* Header */}
            <div className="cart_header">
              <h2>Your cart</h2>
              <Link to="/">Continue shopping</Link>
            </div>

            {/* Table Head */}
            {cartItems.length > 0 && (
              <div className="cart_table_head">
                <span className="th_product">PRODUCT</span>
                <span className="th_quantity">QUANTITY</span>
                <span className="th_total">TOTAL</span>
              </div>
            )}

            {/* Cart Items */}
            {cartItems.length === 0 ? (
              <div className="cart_empty">
                <i className="fa-solid fa-cart-shopping" />
                <p>Your cart is empty.</p>
                <a href="#">Continue shopping</a>
              </div>
            ) : (
              <div className="cart_items">
                {cartItems.map((item) => (
                  <div className="cart_item" key={item.id}>

                    {/* Product */}
                    <div className="cart_product">
                      <img src={item.image} alt={item.name} />
                      <div className="cart_product_info">
                        <p className="cart_product_name">{item.name}</p>
                        <span className="cart_product_price">
                          Rs. {item.price.toLocaleString("en-IN")}.00
                        </span>
                      </div>
                    </div>

                    {/* Quantity */}
                    <div className="cart_quantity">
                      <div className="qty_controls">
                        <button onClick={() => decreaseQty(item.id)}>−</button>
                        <span>{item.quantity}</span>
                        <button onClick={() => increaseQty(item.id)}>+</button>
                      </div>
                      <button
                        className="delete_btn"
                        onClick={() => deleteItem(item.id)}
                        title="Remove item"
                      >
                       <i class="bi bi-trash-fill"></i>
                      </button>
                    </div>

                    {/* Total */}
                    <div className="cart_item_total">
                      Rs. {(item.price * item.quantity).toLocaleString("en-IN")}.00
                    </div>

                  </div>
                ))}
              </div>
            )}

            {/* Summary */}
            {cartItems.length > 0 && (
              <div className="cart_summary">
                <div className="cart_estimated">
                  <span className="est_label">Estimated total</span>
                  <span className="est_value">
                    Rs. {estimatedTotal.toLocaleString("en-IN")}.00
                  </span>
                </div>
                <p className="cart_tax_note">
                  Taxes, discounts and{" "}
                  <a href="#">shipping</a> calculated at checkout.
                </p>
                <button className="checkout_btn">Check out</button>
              </div>
            )}

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddCard;